import { useEffect } from 'react';

/* Wendet den im Dashboard vorgewählten Tag/Nacht-Modus an
   (localStorage 'stig-theme') — kein Umschalten während der Präsentation. */
export default function ThemeToggle() {
  useEffect(() => {
    const light = localStorage.getItem('stig-theme') === 'light';
    document.body.classList.toggle('pres-theme-light', light);
    return () => document.body.classList.remove('pres-theme-light');
  }, []);
  return null;
}
